import Icon from '~/src/common/components/Icon';

import * as S from './layout';
import { getIconList } from './utils';

const MAX_SCORE = 5;
const SHOW_HALVES = false;
const ICONS_NAMES = { '🌕': 'star-full', '🌗': 'star-half', '🌑': 'star-empty' } as const;

interface Props {
  // Props principales
  rating?: { average: number; nbRatings?: number };
  options?: { showHalves?: boolean; maxScore?: number };
  onClick?: () => void;
  // Pour surcharge de l'affichage
  renderNbRatings?: (count: number) => Nullable<string | number>;
  renderAverage?: (score: number) => Nullable<string | number>;
  className?: string;
}

export const Rating = ({ rating, options, onClick, ...rest }: Props) => {
  if (rating == null) return null;
  const { average, nbRatings = 0 } = rating;
  const maxScore = options?.maxScore ?? MAX_SCORE;
  const showHalves = options?.showHalves ?? SHOW_HALVES;
  const finalOptions = { showHalves, maxScore };

  const renderNbRatings = rest.renderNbRatings ?? (v => `(${v})`);
  const renderAverage = rest.renderAverage ?? (v => v.toFixed(1).replace('.', ','));

  const displayedNbRatings = renderNbRatings(nbRatings);
  const displayedAverage = renderAverage(average);

  return (
    <S.RatingContainer {...rest} onClick={() => onClick?.()}>
      <S.StarsContainer role="meter" aria-valuenow={average} aria-valuemin={0} aria-valuemax={5}>
        {getIconList(rating.average, finalOptions).map((mode, idx) => {
          const key = `${idx}-${mode}`;
          const name = ICONS_NAMES[mode];
          return <Icon key={key} name={name} color="inherit" />;
        })}
      </S.StarsContainer>
      {displayedAverage != null ? <p>{displayedAverage}</p> : null}
      {displayedNbRatings != null ? <p>{displayedNbRatings}</p> : null}
    </S.RatingContainer>
  );
};
